import useAuthority from "../../hooks/useAuthority";
import { AUTHORITY_TYPE } from "../../const";

const InputRenderer = ({
  onChangeHandler,
  type = "text",
  value,
  readOnly = false,
  form = "-",
  field = "-",
  module = "-",
  authenticated = false,
  editMode = false,
  disabled = false,
  width = "250px",
  style = {},
  ...props
}) => {
  const { view } = useAuthority({
    type: AUTHORITY_TYPE.FIELD,
    module: module,
    field: field,
    form: form,
    editMode: editMode,
    authenticated: authenticated,
  });

  return (
    <form className="ui form" style={{ width: width }}>
      <div className="field">
        {readOnly ? (
          <input type={type} value={value} readOnly style={style} />
        ) : (
          <input
            style={view ? (style ? { ...style } : {}) : { display: "none" }}
            disabled={disabled}
            type={type}
            value={value}
            onChange={onChangeHandler}
            {...props}
          />
        )}
      </div>
    </form>
  );
};

export default InputRenderer;
